import React, {Component} from 'react';

class Authenticator extends Component {
    constructor(props) {
        super(props);
        this.firstLetter = "JC";
        this.email = "jean-christophe@fundovino.fr"
    }

    render() {
        return (
            <div className="authentication navbar-nav flex-row ml-md-auto d-none d-md-flex">
                <div className="login-icon-name">{this.firstLetter}</div>
                <div className="login-name">{this.email}</div>
            </div>
        );
    }
}

export default Authenticator;